import type { Language, Translation } from '@/shared/providers/i18n/types'

const LEGAL_BASE_URL = 'https://legal.volka.com'

export const LEGAL_LINKS = [
    { key: 'LINK_LEGAL_TERMS', path: 'terms-of-service/' },
    { key: 'LINK_LEGAL_PRIVACY', path: 'privacy-policy/' },
    { key: 'LINK_LEGAL_COOKIES', path: 'cookies/' },
    { key: 'LINK_IMPRESSUM', path: 'impressum/', lang: 'de' },
    { key: 'LINK_NOTATION_JP', path: 'notation/', lang: 'ja' },
] satisfies { key: keyof Translation; path: string; lang?: Language }[]

export function getLegalLinkHref(lang: Language, path: string) {
    return `${LEGAL_BASE_URL}/${lang}/${path}`
}
